// extracted by mini-css-extract-plugin
module.exports = {"header":"header--1kfqI","alert":"alert--2OUx6","form":"form--2z9OI","btn-line":"btn-line--2F49K","long":"long--3JFXn"};